import React from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';
import Flag from '../../../flag';
import LanguageSelectFlag from '../flag';
import { GROUP_OPTION_TYPE, OPTION_TYPE } from '../../types';

const ValueContainer = (props) => {
  const {
    hasValue,
    children,
    selectProps: { value, inputValue },
  } = props;
  return (
    <components.ValueContainer
      {...props}
      isHidden={false}
      className="ws-ui-language-select-value-container"
    >
      {inputValue && hasValue ? (
        <LanguageSelectFlag>{value.iconComponent}</LanguageSelectFlag>
      ) : (
        <LanguageSelectFlag>
          <Flag code="us" />
        </LanguageSelectFlag>
      )}
      {children}
    </components.ValueContainer>
  );
};

ValueContainer.propTypes = {
  hasValue: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  selectProps: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.shape(GROUP_OPTION_TYPE), PropTypes.shape(OPTION_TYPE)]),
    inputValue: PropTypes.string,
  }).isRequired,
};

export default ValueContainer;
